export const getVersion = () => {
  if (process.env.NODE_ENV !== 'production') {
    return '1';
  }

  if (process.browser) {
    const versionFromMetaTag = document
      .querySelector("meta[name='version']")
      ?.getAttribute('content');
    if (versionFromMetaTag) {
      return versionFromMetaTag;
    }
    throw new Error(`Received Version from Meta Tags as ${versionFromMetaTag}`);
  }

  return process.env.VERSION ?? 'no_version';
};

export const getVersionName = () => {
  if (process.env.NODE_ENV !== 'production') {
    return 'dev';
  }

  if (process.browser) {
    const versionFromMetaTag = document
      .querySelector("meta[name='version_name']")
      ?.getAttribute('content');
    if (versionFromMetaTag) {
      return versionFromMetaTag;
    }
    throw new Error(`Received Version from Meta Tags as ${versionFromMetaTag}`);
  }

  return process.env.VERSION_NAME ?? 'no_version_name';
};
